import Axios from "axios";
import Jsonp from "jsonp";
import store from "@/store";

const getHeaderConfig = () => ({
  source: store.state.source,
  version: store.state.version,
  ip: store.state.ip,
  token: store.state.token,
  reqId: store.state.reqId + new Date().getTime().toString(),
  appNum: store.state.appNum,
  activityID: store.state.activityID,
  // 提交前要注释下面的
  // source: "h5",
  // version: "1.0.0",
  // ip: "127.0.0.1",
  // token: store.state.token || "ba2261218ddb44ff89cab42e3df2a1e6",
  // reqId: new Date().getTime().toString(),
  // appNum: 1,
});

// 0bc0cd89b01d4f34a2358cbb45ff1e35
const client = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 15000,
  // headers: {
  //   token: "7eecb0abbd9942e489a93342aacd35b4",
  //   source: "h5",
  //   version: "1.0.0",
  //   ip: "127.0.0.1",
  //   reqId: new Date().getTime().toString(),
  //   appNum: 0,
  // },
});

export async function request(url, config = {}) {
  const result = await client
    .request({ url, ...config, headers: { ...getHeaderConfig() } })
    .catch((error) => console.log(error, "error"));
  return result.data;
}

export function getJsonData(url, cbName) {
  return new Promise((resolve) => {
    window[cbName] = (data) => {
      resolve(data);
    };
    Jsonp(url, null, null);
  });
}
